export enum FiltersAndColumnsKind {
    Child = 'child',
    Employee = 'employee',
}

export enum SettingsKind {
    Filters = 'filters',
    Columns = 'columns',
}

export enum ColumnType {
    String = 'string',
    Object = 'object',
    Gender = 'gender',
    Date = 'date',
    Time = 'time',
}
